"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable */


var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "36",
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    style: {
      mixBlendMode: 'luminosity'
    }
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.0908 35.9999C28.7307 35.9999 36.5453 28.1852 36.5453 18.5454C36.5453 8.90553 28.7307 1.09088 19.0908 1.09088C9.45099 1.09088 1.63635 8.90553 1.63635 18.5454C1.63635 28.1852 9.45099 35.9999 19.0908 35.9999Z",
    fill: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M32.9089 14.9091C32.9089 24.549 25.0942 32.3636 15.4544 32.3636C11.5621 32.3636 7.96745 31.0896 5.06458 28.9359C8.245 33.2222 13.3435 36 19.0909 36C28.7307 36 36.5454 28.1853 36.5454 18.5455C36.5454 12.7979 33.7673 7.69913 29.4807 4.51874C31.6347 7.42172 32.9089 11.0166 32.9089 14.9091Z",
    fill: "#FFD13E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.63634 15.6363L7.38419 14.5153C2.93729 10.5398 0 7.90484 0 4.69205C0 2.06866 2.08302 0 4.75116 0C6.24906 0 7.68845 0.693406 8.63634 1.77974C9.57253 0.693406 11.0236 0 12.5215 0C15.178 0 17.2727 2.05711 17.2727 4.69205C17.2727 7.91639 14.3354 10.5398 9.88849 14.5269L8.63634 15.6363Z",
    fill: "#FF183F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.3638 15.6363L28.1116 14.5153C23.6647 10.5398 20.7274 7.90484 20.7274 4.69205C20.7274 2.06866 22.8104 0 25.4786 0C26.9765 0 28.4159 0.693406 29.3638 1.77974C30.2999 0.693406 31.751 0 33.2489 0C35.9054 0 38.0001 2.05711 38.0001 4.69205C38.0001 7.91639 35.0628 10.5398 30.6159 14.5269L29.3638 15.6363Z",
    fill: "#FF183F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.54541 18.1646V23.671C8.54541 23.671 8.94203 33.8009 19.0908 33.8009C29.2396 33.8009 29.6363 23.671 29.6363 23.671V18.1646H8.54541Z",
    fill: "black"
  })));
};

exports.default = _default;